/**
 * Group invite links (https://namat.org.sa/group/{groupId}): the link the
 * mobile app shares from the group info sheet. With the app installed the OS
 * opens the app (apple-app-site-association / assetlinks); otherwise this
 * page shows the group and where to get the app. Pure, no Firebase.
 */

export const INVITE_HOST = 'https://namat.org.sa';
export const APP_STORE_URL = 'https://apps.apple.com/app/id6759588669';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.namat.mobile';

/** The https link the app shares for a group. */
export function groupInviteUrl(groupId: string): string {
  return `${INVITE_HOST}/group/${encodeURIComponent(groupId)}`;
}

/** The app's own scheme for the same group (tried from the page's «open» button). */
export function groupAppUrl(groupId: string): string {
  return `namat://group/${encodeURIComponent(groupId)}`;
}

export type InviteDevice = 'ios' | 'android' | 'other';

export function inviteDevice(userAgent: string): InviteDevice {
  const ua = userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && /Mobile/i.test(ua))) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

/** Store links to show: the device's own store first, both on a computer. */
export function storeLinks(device: InviteDevice): Array<{ store: 'apple' | 'google'; url: string }> {
  const apple = { store: 'apple' as const, url: APP_STORE_URL };
  const google = { store: 'google' as const, url: PLAY_STORE_URL };
  if (device === 'ios') return [apple];
  if (device === 'android') return [google];
  return [apple, google];
}

/** A valid supportGroups id from the route (no slashes, not empty). */
export function inviteGroupId(raw: string | undefined): string | null {
  const id = (raw || '').trim();
  return /^[A-Za-z0-9_-]{1,128}$/.test(id) ? id : null;
}
